// slugsToGrant returns the connection slugs a new app should be granted, given
// the chosen grant mode and, for "selected", which the owner ticked. Pure, so
// the grant rule is tested without the dialog. "selected" is filtered to real
// connections, so a stale tick (a connection removed meanwhile) grants nothing.
export function slugsToGrant(mode, selectedSlugs, connections) {
  const all = (connections || []).map((c) => c.slug);
  if (mode === "all") {
    return all;
  }
  if (mode === "selected") {
    const chosen = new Set(selectedSlugs || []);
    return all.filter((slug) => chosen.has(slug));
  }
  return [];
}

// initialGrant is what the new-app dialog starts on: the owner's
// include-by-default connections, preselected (so the dialog shows what the
// app will get and the person can still change it); none when there are none.
export function initialGrant(connections) {
  const selected = (connections || []).filter((c) => c.default_grant).map((c) => c.slug);
  return selected.length > 0 ? { mode: "selected", selected } : { mode: "none", selected: [] };
}
